'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _reactRouterDom = require("react-router-dom");
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function (e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (const t in e) "default" !== t && {}.hasOwnProperty.call(e, t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, t)) && (i.get || i.set) ? o(f, t, i) : f[t] = e[t]); return f; })(e, t); }
let app = window.app;
const googleAnalytics = window.ga;
class AppWrapper extends _react.Component {
  constructor(props) {
    super(props);
    app.router_history = props.history;
  }
  UNSAFE_componentWillUpdate(prevProps) {
    const component = this,
      props = this.props,
      state = this.state;
    if (props.location.pathname !== prevProps.location.pathname) {
      window.scrollTo(0, 0);
      if (googleAnalytics instanceof Function) {
        googleAnalytics('set', 'page', props.location.pathname);
        googleAnalytics('send', 'pageview');
      }
    }
  }
  render() {
    const component = this,
      props = this.props,
      state = this.state;
    return /*#__PURE__*/_react.default.createElement(_reactRouterDom.Switch, null, " ", props.routes, " ");
  }
}
var _default = exports.default = (0, _reactRouterDom.withRouter)(props => /*#__PURE__*/_react.default.createElement(AppWrapper, props));
